<template>

  <div>
    <v-dialog
      v-model="transactionSuccessful"
      :width="$store.getters.getAppWidth - 10"
    >
      <v-card>
        <v-card-title
          class="headline green white--text">
          Transaction successful
          <v-spacer></v-spacer>
          <v-icon style="color:#fff;">check</v-icon>
        </v-card-title>

        <v-card-text>
          <v-flex>Thank you for ordering your badge id card. </v-flex>

          <v-flex class="mt-1">You will receive your badge in <strong>7 business days</strong>.</v-flex>

          <v-flex class="mt-1"><strong>Order details:</strong>
            1 badge &dash; {{selectedBadgePrice.name}} <span
              class="title">${{selectedBadgePrice.price}}</span></v-flex>

          <v-flex>
              <strong>Transaction Id:</strong> <span class="primary--text subheading"
                                                     style="font-size: 18px!important;">{{braintreeTransactionId}}</span>
          </v-flex>
          <em>Please note transaction id for future reference.</em>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="goToProgramLevels"
          >
            Home
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-if="badgeDialog !== 0 && transactionSuccessful === false"
      persistent
      v-model="examCompleteDialogPass"
      :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-card-title
          primary-title
          v-if="orderBadge === false && displayBadgeEmailForm === false"
        >
          <v-layout>
            <v-flex style="text-align: center">
              <v-btn-toggle v-model="badgeNCertificate" light>
                <v-btn text value="badge" color="primary">
                  Badge
                </v-btn>
                <v-btn text value="certificate" color="primary">
                  Certificate
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-title dark
                      primary class="title primary white--text py-3 font-weight-regular text-xs-center"
                      v-if="orderBadge === true"
        >

          {{badgeOrderStepTitle}} <span v-if="paymentStep > 1">&mdash;&nbsp;
            <small>1 badge &dash; {{selectedBadgePrice.name}} <span
              class="title">${{selectedBadgePrice.price}}</span></small>
          </span>
        </v-card-title>

        <v-card-title dark
                      primary class="title primary white--text py-3 font-weight-regular text-xs-center"
                      v-if="orderBadge === false && displayBadgeEmailForm === true"
        >
          Email badge
        </v-card-title>

        <v-card-text v-if="badgeNCertificate === 'badge'">

          <v-flex v-if="orderBadge === false && displayBadgeEmailForm === false">

            <v-flex v-if="page === 'exam'">You pass with a score
              of <strong>{{badgeScore}}</strong> and have been badged to certify results.
              Check your email for full result details.
            </v-flex>

            <v-flex v-if="page === 'programLevels'">The most recent exam score is {{badgeScore}}%.
              To change your name, picture or expire date you must
              re-take and pass the exam.
            </v-flex>

            <v-flex pa-2 xs12 class="text-xs-center">

              <img class="elevation-10" v-if="frontBadgeImg" style="height:150px;border-radius: 10px;"
                   :src="frontBadgeImg">
              <v-img class="pa-5" v-if="frontBadgeImg === ''">
                <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
              </v-img>

              <p>Wallet size</p>
            </v-flex>
            <v-flex>
              <v-btn color="success" @click="orderBadgeCard"
                     block><img src="static/images/order_badge.png" height="35">&nbsp;&nbsp;Order
                badge ID card
              </v-btn>
              <v-btn color="primary" @click="displayBadgeEmailForm = true" block>
                <img src="static/images/email_badge.png" height="35">&nbsp;&nbsp;Send badge in email
              </v-btn>
            </v-flex>
          </v-flex>
          <!--- SEND BADGE IN EMAIL --->
          <v-flex v-if="orderBadge === false && displayBadgeEmailForm === true">
            <v-form
              ref="badgeEmailForm"
              v-model="badgeEmailFormValid"
            >
              <v-flex mb-1>The badge will be emailed in text with PDF attachment.</v-flex>
              <v-flex mb-1>To: <span class="primary--text" style="text-decoration: underline;">{{userEmail}}</span>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="badgeEmails"
                  :rules="badgeEmailsRules"
                  label="E-mail"
                ></v-text-field>
              </v-flex>
              <v-flex>Separate multiple addresses with commas (limit 10). We will not share these addresses with any
                third parties.
              </v-flex>
              <v-flex>
                <v-btn @click="validateSendBadgeInEmail" :disabled="!badgeEmailFormValid"
                       :loading="loadingSendBadgeMail" block color="primary">Send
                </v-btn>
              </v-flex>
            </v-form>
          </v-flex>
          <!--  ORDER BADGE -->
          <v-flex v-if="orderBadge === true">
            <v-stepper v-model="paymentStep" alt-labels class="elevation-0 pa-0">

              <v-stepper-content step="1">
                <p class="text-xs-center">Your badge will be credit-card size on durable, high-quality laminate</p>
                <v-flex xs12 class="text-xs-center pt-1">
                  <v-btn-toggle v-model="badgeImage">
                    <v-btn text color="primary" value="front" small>
                      Front
                    </v-btn>
                    <v-btn text color="primary" value="back" small>
                      Back
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>

                <v-flex pa-2 xs12 class="text-xs-center">
                  <img class="elevation-10" v-if="badgeImage === 'front' && frontBadgeImg"
                       style="height:150px;border-radius: 10px;" :src="frontBadgeImg">
                  <v-img class="pa-5" v-if="badgeImage === 'front' && frontBadgeImg === ''">
                    <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
                  </v-img>

                  <img class="elevation-10" v-if="badgeImage === 'back' && backImg"
                       style="height:150px;border-radius: 10px;" :src="backImg">
                </v-flex>

                <v-flex>
                  <v-btn v-for="(pricing, index) in badgePricing.products" block dark
                         :color="pricingBtnColor(index)" :key="index"
                         @click="selectBadgePrice(pricing)"
                         style="height:50px;text-transform: inherit;">
                    <v-layout align-center justify-center text-xs-left>
                      <v-flex class="headline">${{pricing.price}}</v-flex>
                      <v-flex>
                        <v-layout column>
                          <v-flex>{{pricing.name}}</v-flex>
                          <v-flex>Arrives in {{pricing.daysToDeliver}} business days</v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                </v-flex>
              </v-stepper-content>

              <v-stepper-content step="2" class="pt-1 pb-0 px-0">
                <!--<v-flex class="blue&#45;&#45;text font-weight-medium mb-2 pb-2 subheading text-xs-center">1 badge &dash; {{selectedBadgePrice.name}} ${{selectedBadgePrice.price}}</v-flex>-->
                <v-form
                  ref="shippingForm"
                  v-model="shippingValid"
                  lazy-validation
                >
                  <v-container>
                    <v-layout wrap>

                      <v-flex xs12 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingFullName"
                          :rules="nameRules"
                          label="Full name"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingAddress1"
                          :rules="addressRules"
                          label="Address line1"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingAddress2"
                          label="Address line2"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingCity"
                          :rules="cityRules"
                          label="City"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingState"
                          :rules="stateRules"
                          label="State / Region"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs6 pa-0>
                        <v-text-field
                          class="pt-2"
                          v-model="shippingPostal"
                          :rules="postalCodeRules"
                          label="Postal code"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs6 pa-0>
                        <v-text-field
                          class="pt-2"
                          label="Country"
                          v-model="shippingCountry"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 pa-0>
                        <v-switch class="pa-0 mt-1" v-model="locationService">
                          <template v-slot:label>
                            Use location services
                            <v-progress-circular v-if="locationLoader" :indeterminate="locationService" :value="0"
                                                 size="24" class="ml-2"></v-progress-circular>
                          </template>
                        </v-switch>
                      </v-flex>
                      <v-flex xs4 pa-0>
                        <v-btn
                          flat
                          class="ml-0"
                          @click="paymentStep = 1"
                        >
                          <v-icon>arrow_back</v-icon>
                          Back
                        </v-btn>
                      </v-flex>

                      <v-flex xs8 pa-0 class="text-xs-right">
                        <v-btn
                          class="mr-0"
                          :disabled="!shippingValid"
                          color="success"
                          @click="validateShippingAddress"
                        >
                          Confirm and Continue
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>

                </v-form>
              </v-stepper-content>

              <v-stepper-content step="3" class="pt-1 pb-0 px-0">

                <v-container>
                  <v-layout v-if="clientToken!== 0">
                    <v-flex>
                      <!------------- BRAINTREE INTEGRATION ------------>
                      <payment :token="clientToken" :paypal="true" :userId="badgeDetails.userId"
                               :orderId="badgeOrderDetails.orderId"
                               :amount="this.selectedBadgePrice.price"></payment>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else wrap>

                    <v-flex xs6>
                      <v-layout column>
                        <v-flex><h4 class="subheading mb-2 font-weight-bold">Shipping address:</h4></v-flex>
                        <v-flex pl-2>{{shippingFullName}}</v-flex>
                        <v-flex pl-2>{{shippingAddress1}}</v-flex>
                        <v-flex pl-2>{{shippingAddress2}}</v-flex>
                        <v-flex pl-2>{{shippingCity}}</v-flex>
                        <v-flex pl-2>{{shippingState}}</v-flex>
                        <v-flex pl-2>{{shippingPostal}}</v-flex>
                        <v-flex pl-2>{{shippingCountry}}</v-flex>
                        <v-flex>
                          <v-btn class="pa-0 ma-0 mt-2" flat color="primary" @click="paymentStep = 2">
                            <v-icon>edit</v-icon>&nbsp;Edit Address
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs6>
                      <v-container>
                        <v-layout column>
                          <v-flex class="text-xs-center">Confirm the shipping address before continuing to payments
                          </v-flex>
                          <v-flex>
                            <v-btn block color="success" :loading="payLoading" @click="createBadgeOrder">
                              Pay now
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>

                  </v-layout>
                </v-container>


              </v-stepper-content>
            </v-stepper>
          </v-flex>

        </v-card-text>

        <v-card-text v-if="badgeNCertificate === 'certificate'">
          <v-flex pa-2 xs12 class="text-xs-center">
            <img class="elevation-10" v-if="certificateImg"
                 style="height:200px;" :src="certificateImg">
            <v-img class="pa-5" v-if="certificateImg === ''">
              <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
            </v-img>
            <div>5 inches high X 7 inches wide</div>
          </v-flex>
          <v-flex>
            <v-btn color="primary" block :disabled="certificateMailSend"
                   :loading="loadingSendCertificateMail"
                   @click="sendCertificateMail">Email a certificate (PDF)
            </v-btn>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="paymentStep === 1">
          <v-spacer></v-spacer>
          <v-btn
            :color="page === 'exam' ? 'primary' : 'error'"
            flat
            @click="closeDialog"
          >
            {{ page === 'exam'?'Home' : 'Close' }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
  import Payment from './Payment'
  export default {
    name: 'BadgeButton',
    components: {Payment},
    props: { badgeDialog: Number, page: String },
    data () {
      return {
        locationService: false,
        shippingValid: true,
        shippingFullName: '',
        shippingAddress1: '',
        shippingAddress2: '',
        shippingCity: '',
        shippingState: '',
        shippingPostal: '',
        shippingCountry: 'United States',
        badgeOrderStepTitle: 'Confirm Badge Order Purchase',
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length > 2) || 'Please enter full name'
        ],
        addressRules: [
          v => !!v || 'Address is required',
          v => (v && v.length > 2) || 'Please enter full address'
        ],
        cityRules: [
          v => !!v || 'City is required'
        ],
        stateRules: [
          v => !!v || 'State is required'
        ],
        postalCodeRules: [
          v => !!v || 'Postal code is required',
          v => /^\d+$/.test(v) || 'Postal code should be numeric'
        ],
        paymentStep: 1,
        examCompleteDialogPass: false,
        badgeNCertificate: 'badge',
        badgeImage: 'front',
        frontBadgeImg: '',
        backImg: '',
        // backBadgeImg: '',
        selectedBadgePrice: {},
        orderBadge: false,
        certificateImg: '',
        certificateMailSend: false,
        loadingSendCertificateMail: false,
        badgeMailSend: false,
        badgeEmails: [],
        loadingSendBadgeMail: false,
        displayBadgeEmailForm: false,
        courseId: process.env.GAME_ID,
        badgeEmailsRules: [
          v => /^$|^((\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+))$/g.test(v) || 'E-mail must be valid'
        ],
        badgeEmailFormValid: true
      }
    },
    created () {
      if (this.badgeScore > 0) {
        this.shippingFullName = ''
        this.shippingAddress1 = ''
        this.shippingAddress2 = ''
        this.shippingCity = ''
        this.shippingState = ''
        this.shippingPostal = ''
        this.getBadgeImages()
        this.$store.dispatch('course/fetchBadgeDetails', {deckId: this.tagDeckId, userId: this.user.id})
      }
    },
    computed: {
      badgeOrderDetails () {
        return this.$store.getters['braintree/getBadgeOrderDetails']
      },
      braintreeTransactionId () {
        return this.$store.getters['braintree/getTransactionId']
      },
      transactionSuccessful: {
        get: function () {
          return this.$store.getters['braintree/getTransactionSuccessful']
        },
        set: function (status) {
          this.$store.commit('braintree/setTransactionSuccessful', status)
        }
      },
      clientToken () {
        return this.$store.getters['braintree/getClientToken']
      },
      payLoading () {
        return this.$store.getters['braintree/getPayLoading']
      },
      badgeDetails () {
        return this.$store.getters['course/getBadgeDetails']
      },
      badgeScore: function () {
        return this.$store.getters['course/getBadgeScore']
      },
      user: {
        get: function () {
          return this.$store.getters['user/getUserDetails']
        },
        set: function () {
          // setting db object
        }
      },
      userAddress () {
        const address = this.$store.getters['course/getUserAddress']
        this.shippingFullName = address.fullName
        this.shippingAddress1 = address.addressLine1
        this.shippingAddress2 = address.addressLine2
        this.shippingCity = address.city
        this.shippingState = address.state
        this.shippingPostal = address.zip
        this.shippingCountry = address.country
        return address
      },
      badgePricing () {
        return this.$store.getters['course/getBadgePricing']
      },
      locationLoader: {
        get: function () {
          return this.$store.getters['course/getLocationLoader']
        },
        set: function (status) {
          this.$store.commit('course/setLocationLoader', status)
        }
      },
      group () {
        return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId())
      },
      tagDeckId () {
        return this.group.decks[0].regId
      },
      userEmail: function () {
        return this.user.email
      }
    },
    methods: {
      createBadgeOrder () {
        const data = {
          'productCode': this.selectedBadgePrice.productCode,
          'badgeId': this.badgeDetails.id,
          'quantity': 1,
          'amount': this.selectedBadgePrice.price,
          'userId': this.badgeDetails.userId,
          'fullName': this.shippingFullName,
          'addressLine1': this.shippingAddress1,
          'addressLine2': this.shippingAddress2,
          'city': this.shippingCity,
          'state': this.shippingState,
          'zip': this.shippingPostal,
          'country': this.shippingCountry
        }
        this.$store.dispatch('braintree/createBadgeOrder', data)
      },
      goToProgramLevels () {
        this.transactionSuccessful = false
        this.examCompleteDialogPass = false
        this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId(), groupId: this.groupId()}})
      },
      closeDialog () {
        this.examCompleteDialogPass = false
        if (this.page === 'exam') {
          this.goToProgramLevels()
        }
      },
      groupId () {
        return typeof this.$route.params.groupId !== 'undefined'
          ? parseInt(this.$route.params.groupId) : parseInt(this.groups[0].groupId)
      },
      deckId () {
        return typeof this.$route.params.deckId !== 'undefined'
          ? parseInt(this.$route.params.deckId) : parseInt(this.groups[0].decks[0].id)
      },
      getBadgeImages () {
        this.$store.dispatch('exam/fetchCertificateImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.certificateImg = prefix + img
        })
        this.$store.dispatch('exam/fetchBadgeFrontImageNew', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.frontImg = prefix + img
        })
        this.$store.dispatch('exam/fetchBadgeBackImageNew', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.backImg = prefix + img
        })
        this.$store.dispatch('exam/fetchBadgeFrontImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.frontBadgeImg = prefix + img
        })
        // this.$store.dispatch('exam/fetchBadgeBackImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
        //   let prefix = 'data:' + data.headers['content-type'] + ';base64,'
        //   let img = Buffer.from(data.data, 'binary').toString('base64')
        //   this.backBadgeImg = prefix + img
        // })
      },
      sendCertificateMail () {
        const badgeId = this.badgeDetails.id
        this.loadingSendCertificateMail = true
        this.$store.dispatch('exam/sendCertificateMail', badgeId).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.certificateMailSend = true
          this.loadingSendCertificateMail = false
          this.closeDialog()
        })
      },
      sendBadgeMail () {
        const badgeId = this.badgeDetails.id
        this.loadingSendBadgeMail = true
        this.$store.dispatch('exam/sendBadgeMail', {emails: this.badgeEmails, badgeId: badgeId}).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.badgeMailSend = true
          this.loadingSendBadgeMail = false
          this.badgeEmailFormValid = false
          this.closeDialog()
        })
      },
      orderBadgeCard () {
        this.orderBadge = true
        // console.log('Order Badge Started')
      },
      showBadgeDetails () {
        this.badgeEmailFormValid = true
        this.certificateMailSend = false
        this.orderBadge = false
        this.displayBadgeEmailForm = false
        this.badgeNCertificate = 'badge'
        this.examCompleteDialogPass = true
        this.$store.dispatch('course/fetchBadgePricing', this.tagDeckId)
      },
      validateSendBadgeInEmail () {
        if (this.$refs.badgeEmailForm.validate()) {
          // console.log('validateSendBadgeInEmail')
          this.sendBadgeMail()
        }
      },
      validateShippingAddress () {
        if (this.$refs.shippingForm.validate()) {
          // console.log('Form Validated')
          this.paymentStep = 3
        }
      },
      selectBadgePrice (pricing) {
        this.selectedBadgePrice = pricing
        this.paymentStep = 2
      },
      pricingBtnColor (index) {
        switch (index) {
          case 0 : return 'primary'
          case 1 : return 'green darken-1'
          default : return 'primary'
        }
      }
    },
    watch: {
      locationService (status) {
        if (status === true) {
          // console.log('Fetch Location...')
          this.$store.dispatch('course/fetchUserAddress', this.courseId)
        }
      },
      badgeDialog (newVal) {
        if (newVal !== 0) {
          this.showBadgeDetails()
          this.getBadgeImages()
          this.$store.dispatch('course/fetchBadgeDetails', {deckId: this.tagDeckId, userId: this.user.id})
        }
      },
      userAddress (address) {
        if (Object.keys(address).length > 0) {
          this.shippingFullName = address.fullName
          this.shippingAddress1 = address.addressLine1
          this.shippingAddress2 = address.addressLine2
          this.shippingCity = address.city
          this.shippingState = address.state
          this.shippingPostal = address.zip
          this.shippingCountry = address.country
          this.locationLoader = false
        } else {
          this.locationLoader = true
        }
      },
      paymentStep (step) {
        switch (step) {
          case 1: this.badgeOrderStepTitle = 'Confirm Badge ID Purchase'
            break
          case 2: this.badgeOrderStepTitle = 'Shipping Address'
            break
          case 3: this.badgeOrderStepTitle = 'Payment'
            break
          default: this.badgeOrderStepTitle = ''
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/widgets/BadgeButton.vue